import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

export const tgaOnionDashboardRoutes: Routes = [
  {
    path: 'tga-onion-dashboard',
    loadComponent: () =>
      import('./tga-onion-dashboard.component').then((m) => m.TgaOnionDashboardComponent),
    canActivate: [CustomerGuard],
  },
];
